function watchDarkMode() {
  const toggleSwitch = document.querySelector('.theme-switch input[type="checkbox"]');
  const currentTheme = localStorage.getItem('theme') ? localStorage.getItem('theme') : null;
  const darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)');

  function toggleTheme(e) {
    const themeColor = document.querySelector('meta[name="theme-color"]');
    if (e.target.checked) {
      themeColor.content = 'black'
      document.documentElement.setAttribute('data-theme', 'dark');
      e.type === 'change' ? localStorage.setItem('theme', 'dark') : null;
      toggleSwitch.checked = true;
    }
    else {
      themeColor.content = 'white'
      document.documentElement.setAttribute('data-theme', 'light');
      e.type === 'change' ? localStorage.setItem('theme', 'light') : null;
      toggleSwitch.checked = false;
    }
  }

  if (darkModeQuery.matches) {
    toggleTheme({ target: { checked: true }})
  } else if (currentTheme) {
    document.documentElement.setAttribute('data-theme', currentTheme);
    if (currentTheme === 'dark') {
      toggleSwitch.checked = true;
    }
  } else {
    toggleTheme({ target: { checked: false }})
  }

  toggleSwitch.addEventListener('change', toggleTheme, false);
  darkModeQuery.addListener(function(e) {
    const darkModeOn = e.matches
    darkModeOn ? toggleTheme({ target: { checked: true }}) : toggleTheme({ target: { checked: false }})
  })
}

export { watchDarkMode }